import { forwardRef } from 'react';
import Textarea from '../../../../../../components/textarea/Textarea';
import useSectionHighlightRef from '../../../../../../hooks/useSectionHighlightRef';

const Safety = forwardRef(({ tempData, setTempData, isEdit }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Safety Measures</h2>
            <div className='orgPackUpSecDiv' style={{ padding: '10px 5%' }}>
                <div>
                    <p className='tagsNoteP'>
                        Note: Type each point in new(press enter) line (each new point should come in next line). Don't
                        number the points as it will be numbered automatically on the user end
                    </p>
                </div>
                <Textarea
                    label='Safety'
                    name='safety'
                    value={tempData.safety}
                    placeholder='What are the Safety measures taken in this package'
                    setFormData={setTempData}
                    directInDiv='orgPackUpInputDiv'
                    labelCss='orgPackUpLabel'
                    inputCss='orgPackUpInput'
                    min={20}
                    limit={800}
                    error={highlightField === 'safety'}
                />
            </div>
        </div>
    );
});

export default Safety;
